import React from 'react';
import { LoadingBar } from 'ui/NetworkStatusBar';
import { ICrmMetricsResponse } from 'services/DashboardApi/types';
import { ActiveLeadsCard } from './ActiveLeadsCard';
import { SalesFunnelCard } from './SalesFunnelCard';
import { WinLossRatesCard } from './WinLossRatesCard';
import { useResponsive } from 'containers/CRM/hooks/useResponsive';

interface ICrmMetricsKpisDataProps {
  crmMetricsData?: ICrmMetricsResponse;
  isLoadingCrmMetrics: boolean;
  isErrorCrmMetrics: boolean;
}

export const CrmMetricsKpisData: React.FC<ICrmMetricsKpisDataProps> = ({
  crmMetricsData,
  isLoadingCrmMetrics,
  isErrorCrmMetrics,
}) => {
  const { isMobile, isTablet } = useResponsive();

  if (isLoadingCrmMetrics && !crmMetricsData && !isErrorCrmMetrics) {
    return (
      <div className="w-full flex justify-center items-center mt-[20px] mb-[20px]">
        <LoadingBar label="Loading" />
      </div>
    );
  }

  const activeLeads = crmMetricsData?.activeLeads ?? { discovery: 0, nurture: 0, confirmed: 0, total: 0 };
  const winLossRates = crmMetricsData?.winLossRates ?? {
    periodStart: '',
    periodEnd: '',
    wins: 0,
    losses: 0,
    winRate: 0,
    lossRate: 0,
  };
  const pipeline = crmMetricsData?.pipeline ?? {
    stages: [],
    conversionRates: { discoveryToNurture: 0, nurtureToConfirmed: 0 },
  };

  if (isMobile) {
    return (
      <div className="flex flex-col gap-[20px] w-full mb-[20px]">
        <ActiveLeadsCard activeLeads={activeLeads} isErrorCrmMetrics={isErrorCrmMetrics} />
        <WinLossRatesCard winLossRates={winLossRates} isErrorCrmMetrics={isErrorCrmMetrics} />
        <SalesFunnelCard pipeline={pipeline} isErrorCrmMetrics={isErrorCrmMetrics} />
      </div>
    );
  }

  if (isTablet) {
    return (
      <div className="flex flex-col gap-[20px] w-full mb-[20px]">
        <div className="flex gap-[20px] items-stretch">
          <ActiveLeadsCard activeLeads={activeLeads} isErrorCrmMetrics={isErrorCrmMetrics} />
          <WinLossRatesCard winLossRates={winLossRates} isErrorCrmMetrics={isErrorCrmMetrics} />
        </div>
        <SalesFunnelCard pipeline={pipeline} isErrorCrmMetrics={isErrorCrmMetrics} />
      </div>
    );
  }

  return (
    <div className="flex gap-[20px] items-stretch w-full mb-[20px]">
      <ActiveLeadsCard activeLeads={activeLeads} isErrorCrmMetrics={isErrorCrmMetrics} />
      <WinLossRatesCard winLossRates={winLossRates} isErrorCrmMetrics={isErrorCrmMetrics} />
      <SalesFunnelCard pipeline={pipeline} isErrorCrmMetrics={isErrorCrmMetrics} />
    </div>
  );
};
